// ThreadView barrel — IFrameViewer (iframe 모드) 와 InnerViewer (host React
// 트리 직접 마운트) 중 하나를 vars.ts 의 useInnerViewer toggle + mobile 가드로
// 분기 선택해 default 로 export.
//
// docs/iframe-viewer/inner-viewer-task.md §2.7 결정:
//   default = useInnerViewer && !isMobileApp() && !isForcedIFrameViewer()
//             ? InnerViewer : IFrameViewer
//
// - mobile WebView (OfficeMail native app, user-agent 검사) 에서는 toggle 값과
//   무관하게 IFrameViewer 강제 (§2.1 (C)). mobile native bridge 가 iframe
//   contentWindow 에 의존하므로 분리.
// - desktop browser 는 useInnerViewer = true 일 때 InnerViewer 사용. Phase 5
//   default true 전환됨.
// - M3 (code-reviewer) — runtime escape hatch. localStorage 의
//   `__forceIFrameViewer = 'true'` 가 설정되면 InnerViewer toggle 무시하고
//   IFrameViewer 강제. 양산 회귀 발견 시 사용자 단위 rollback 가능 (rebuild /
//   redeploy 없이).
import { useInnerViewer } from 'vars'
import IFrameViewerDefault from './IFrameViewer'
import InnerViewerDefault from './InnerViewer'
import { ThreadView as IFrameViewerClass } from './IFrameViewer'
import { InnerViewer as InnerViewerClass } from './InnerViewer'
import { isMobileApp, isForcedIFrameViewer } from './branchHelpers'

// viewerExt 의 `reactObj: ThreadView` type annotation 이 IFrameViewer 의 클래스
// instance 뿐 아니라 InnerViewer 의 instance 도 받을 수 있도록 union type 으로
// re-export. structural 으로는 두 클래스가 createEmailInfo / applyThread / onReady
// 등 viewerExt 가 사용하는 모든 메서드를 공유한다.
export type ThreadView = IFrameViewerClass | InnerViewerClass

// 분기 helper (`isMobileApp` / `isForcedIFrameViewer`) 는 [./branchHelpers.ts](./branchHelpers.ts)
// 로 분리 — 단위 테스트 시 IFrameViewer/InnerViewer 의 transitive 의존 (DataManager /
// popups 등) 을 회피한다.

const ThreadView =
  useInnerViewer && !isMobileApp() && !isForcedIFrameViewer()
    ? InnerViewerDefault
    : IFrameViewerDefault

export default ThreadView
